var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuReservationSuitcaseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.309 8.487c0-2.38-1.936-4.32-4.309-4.32s-4.309 1.94-4.309 4.32H9.544C9.544 4.911 12.434 2 16 2c3.566 0 6.47 2.911 6.47 6.487h-2.161zM3.074 9.564h25.852A1.07 1.07 0 0130 10.641v17.282A1.07 1.07 0 0128.926 29H3.074A1.07 1.07 0 012 27.923V10.641a1.07 1.07 0 011.074-1.077zM22.456 25.77H20.31V12.808h2.147V25.77zm-12.926 0h2.148V12.808H9.53V25.77z",
    fill: "#228622"
  })));
}

export default SvgIconMenuReservationSuitcaseFilled;